export default "__VITE_ASSET__D6ulhz_q__"